export default __webpack_public_path__ + "static/media/Ship.92bfd651.svg";